import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { companiesService } from '../api/companies.service';

export function useCompanyByIdQuery(companyId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.companies.detail(companyId ?? ''),
    queryFn: () => companiesService.get(companyId!),
    enabled: !!companyId,
  });
}
